import s from "./index5.js";
import { resolveComponent as r, openBlock as u, createBlock as i, withCtx as c, createVNode as a } from "vue";
import p from "../../../../_virtual/index.js";
function m(o, e, d, y, f, C) {
  const t = r("country-selector-more"), n = r("dialog-layout");
  return u(), i(n, {
    variant: o.VARIANTS.ACTION,
    isOpen: o.shouldShowDialog,
    "onUpdate:isOpen": e[0] || (e[0] = (l) => o.shouldShowDialog = l),
    title: "Select your country"
  }, {
    default: c(() => [
      a(t, {
        onClose: o.closeDialog,
        countries: o.countries,
        currentCountry: o.currentCountry
      }, null, 8, ["onClose", "countries", "currentCountry"])
    ]),
    _: 1
  }, 8, ["variant", "isOpen"]);
}
const h = /* @__PURE__ */ p(s, [["render", m]]);
export {
  h as default
};
//# sourceMappingURL=index4.js.map
